import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"
import { motion } from "motion/react"
import { cn } from "@/lib/utils"

const MotionProgressPrimitiveIndicator = motion(ProgressPrimitive.Indicator)

type SafeIndicatorProps = Omit<
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Indicator>,
  | "onAnimationStart"
  | "onAnimationEnd"
  | "onAnimationIteration"
  | "onDrag"
  | "onDragStart"
  | "onDragEnd"
  | "onDragEnter"
  | "onDragLeave"
  | "onDragOver"
  | "onDrop"
>

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    indicatorClassName?: string
    indicatorProps?: SafeIndicatorProps
    markerPosition?: number
  }
>(({ className, value, indicatorClassName, indicatorProps, markerPosition, ...props }, ref) => {
  const { style: indicatorStyle, ...restIndicatorProps } = indicatorProps ?? {}
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        // "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
        "relative h-2 w-full overflow-hidden rounded-full bg-foreground/10",
        className
      )}
      {...props}
    >
      <MotionProgressPrimitiveIndicator
        // className={cn("h-full w-full flex-1 bg-primary transition-all", indicatorClassName)}
        className={cn("h-full w-full flex-1 bg-primary transition-all", indicatorClassName)}
        style={{ transform: `translateX(-${100 - (value || 0)}%)`, ...(indicatorStyle as React.CSSProperties) }}
        {...restIndicatorProps}
        initial={{ transform: 'translateX(-100%)' }}
        animate={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        transition={{
          duration: 0.8,
          ease: 'easeOut',
        }}
      />
      {markerPosition && (
        <div className="absolute top-0 h-full w-0.5 bg-foreground/20" style={{ left: `${markerPosition}%` }} />
      )}
    </ProgressPrimitive.Root>
  )
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
